/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
export const TwoFactorAuthApiEnum = {
    POST_SETUP: (id: string): string => {
        return `/accounts/${id}/2fa/setup`;
    },
    POST_VERIFY: (id: string): string => {
        return `/accounts/${id}/2fa/verify`;
    },
    PUT_DELETE: (id: string): string => {
        return `/accounts/${id}/2fa/disable`;
    }
};
